import produce from 'immer'
import { CardstourdesksAction, CardstourdesksActionTypes } from '../actions/cardstourdesksActions'
import { ApiStatus, ICardstourdesksItem } from '../models'

export const initialCardstourdesksState: ICardstourdesksState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  cardstourdesks: [],
  foundcardstourdesks: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function cardstourdesksReducer(state: ICardstourdesksState = initialCardstourdesksState, action: CardstourdesksAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case CardstourdesksActionTypes.SEARCH_CARDSTOURDESKS:
        draft.searchString = action.searchOptions.searchString
        break
      case CardstourdesksActionTypes.SEARCHING_CARDSTOURDESKS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case CardstourdesksActionTypes.SEARCHING_CARDSTOURDESKS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case CardstourdesksActionTypes.FOUND_CARDSTOURDESKS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundcardstourdesks.push(...action.payload.cardstourdesks.docs)
          : (draft.foundcardstourdesks = action.payload.cardstourdesks.docs)
        draft.totalDocs = action.payload.cardstourdesks.totalDocs
        break

      case CardstourdesksActionTypes.LOAD_CARDSTOURDESKS:
      case CardstourdesksActionTypes.LOADING_CARDSTOURDESKS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundcardstourdesks = []
        break

      case CardstourdesksActionTypes.LOADING_CARDSTOURDESKS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case CardstourdesksActionTypes.LOADED_CARDSTOURDESKS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.cardstourdesks = action.payload.cardstourdesks.docs
        draft.totalDocs = action.payload.cardstourdesks.totalDocs
        break

      case CardstourdesksActionTypes.ADD_CARDSTOURDESKS:
      case CardstourdesksActionTypes.ADDING_CARDSTOURDESKS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case CardstourdesksActionTypes.ADDING_CARDSTOURDESKS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardstourdesksActionTypes.ADDED_CARDSTOURDESKS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.cardstourdesks.push(action.payload.cardstourdesks.docs[0])
        if (draft.searchString) draft.foundcardstourdesks.push(action.payload.cardstourdesks.docs[0])
        break

      case CardstourdesksActionTypes.REMOVE_CARDSTOURDESK:
        draft.cardstourdesks.splice(
          draft.cardstourdesks.findIndex((cardstourdesk) => cardstourdesk._id === action.payload._id),
          1
        )
        break

      case CardstourdesksActionTypes.SOFT_REMOVE_CARDSTOURDESKS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardstourdesksActionTypes.SOFT_REMOVING_CARDSTOURDESKS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardstourdesksActionTypes.SOFT_REMOVED_CARDSTOURDESKS:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardstourdesks.splice(
          draft.cardstourdesks.findIndex((cardstourdesk) => cardstourdesk._id === action.payload._id),
          1
        )
        break

      case CardstourdesksActionTypes.SOFT_REMOVING_CARDSTOURDESKS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardstourdesksActionTypes.EDIT_CARDSTOURDESKS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case CardstourdesksActionTypes.EDITING_CARDSTOURDESKS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardstourdesksActionTypes.EDITED_CARDSTOURDESKS:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardstourdesks[draft.cardstourdesks.findIndex((cardstourdesk) => cardstourdesk._id === action.payload._id)] = action.payload
        draft.foundcardstourdesks[draft.foundcardstourdesks.findIndex((cardstourdesk) => cardstourdesk._id === action.payload._id)] = action.payload
        break

      case CardstourdesksActionTypes.EDITING_CARDSTOURDESKS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ICardstourdesksState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  cardstourdesks: ICardstourdesksItem[]
  foundcardstourdesks: ICardstourdesksItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
